"use client";

import { useEffect } from "react";

/**
 * Registra o service worker.
 *
 * Precisa existir porque o `@serwist/turbopack` **não injeta o registro**: ele
 * serve o service worker como rota e deixa o registro com a aplicação. O
 * `@ducanh2912/next-pwa`, que saiu daqui, injetava esse código nos entrypoints
 * pelo bundler — e era justamente essa dependência de bundler que impedia o
 * Turbopack.
 *
 * Sem este componente o PWA morre em silêncio: `subscription.ts` só faz
 * `getRegistration()` e desiste quando não encontra nada, então push pararia de
 * funcionar sem nenhum erro na tela.
 *
 * O escopo `/` só é aceito porque a rota devolve o header
 * `Service-Worker-Allowed: /`. Um service worker servido de `/serwist/` sem
 * esse header controlaria apenas `/serwist/`, e o cache não pegaria página
 * nenhuma.
 */
const CAMINHO_DO_SW = "/serwist/sw.js";

export function ServiceWorkerRegister() {
  useEffect(() => {
    // Mesma regra do next-pwa antigo: desligado em desenvolvimento. É por isso
    // que bug de cache aqui só reproduz em produção.
    if (process.env.NODE_ENV === "development") return;
    if (!("serviceWorker" in navigator)) return;

    let cancelado = false;

    void navigator.serviceWorker
      .register(CAMINHO_DO_SW, { scope: "/" })
      .then((registro) => {
        if (cancelado) return;
        // Registrar um script URL novo para o mesmo escopo substitui a
        // registration anterior — é o que migra quem ainda tem o `/sw.js`
        // antigo instalado, sem precisar de passo manual.
        return registro.update();
      })
      .catch(() => {
        // Falhar o registro não pode derrubar a página: sem service worker o
        // app funciona, só perde cache offline e notificação.
      });

    return () => {
      cancelado = true;
    };
  }, []);

  return null;
}

export default ServiceWorkerRegister;
